import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { GetMusicBoxContentsRequest } from '../api/wishlist/getmusicboxcontents/getmusicboxcontentsrequest';
import { GetMusicBoxContentsResponse, GetMusicBoxContentsResponseDtoImpl } from '../api/wishlist/getmusicboxcontents/getmusicboxcontentsresponse';
import { GetMusicBoxContentsBuilder } from '../dto/musicboxcontents/getmusicboxcontentsbuilder';
import { GetMusicBoxContentsDtoImpl } from '../dto/musicboxcontents/getmusicboxcontentsdto';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';

export class GetMusicBoxContentsAPIProcessorImpl extends APIProcessorImpl<GetMusicBoxContentsRequest, GetMusicBoxContentsResponse>
{
    private LOGGER: Logger = LogManager.getLogger(GetMusicBoxContentsAPIProcessorImpl.name);
    execute(request: GetMusicBoxContentsRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void {
        this.LOGGER.log("onSuccess() invoked");
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new GetMusicBoxContentsResponseDtoImpl(APIFeatures.MUSIC_BOX_CONTENTS, "Music Box Contents Success");

                let getMusicBoxContentsDto = new GetMusicBoxContentsDtoImpl();
                getMusicBoxContentsDto.setListOfMusicBoxContentsTones(new GetMusicBoxContentsBuilder(responseMapper.getResponseMap(),this.getContext()).buildAll());

                response.setMusicBoxContentsDto(getMusicBoxContentsDto);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new GetMusicBoxContentsResponseDtoImpl(APIFeatures.MUSIC_BOX_CONTENTS, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new GetMusicBoxContentsResponseDtoImpl(APIFeatures.MUSIC_BOX_CONTENTS, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new GetMusicBoxContentsResponseDtoImpl(APIFeatures.MUSIC_BOX_CONTENTS, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
    
            this.getAPIFailure(new GetMusicBoxContentsResponseDtoImpl(APIFeatures.MUSIC_BOX_CONTENTS, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/getmusicboxcontentsapiprocessor.tsx